export const FUND_API_SOURCES = {
    FUND_SHARECLASS_SOURCE: "/cn/api/fund/shareclass/v1/",
    FUND_NAV_SOURCE: "/cn/api/accounting/nav/latest/v1/",
    FUND_ACCUMULATION_SOURCE: "/cn/api/performance/reinvested/price/v1/",
    FUND_LIST_SOURCE: "/cn/api/experience/shareclasses/v1",
    DIVIDEND_SOURCE: "/cn/api/accounting/dividends/v1/",
    DIVIDEND_DOWNLOAD_SOURCE: "/cn/api/accounting/dividends/v1/excel/",
    CHARGES_SOURCE: "/cn/api/experience/charging/v1/",
    MANAGERS_SOURCE: "/cn/api/fund/managers/v1/",
    DISTRIBUTORS_SOURCE: "/cn/api/fund/distributors/v1/",
    FUND_PORTFOLIO_BOND_SOURCE: "/cn/api/portfolio/holdings/v1/bonds/",
    FUND_PORTFOLIO_EQUITY_SOURCE: "/cn/api/portfolio/holdings/v1/equity/",
    FUND_PORTFOLIO_SECURITIES_SOURCE: "/cn/api/portfolio/holdings/v1/securities/",
    FUND_PORTFOLIO_ASSET_SOURCE: "/cn/api/portfolio/composition/asset/allocation/v1/",
    FUND_PORTFOLIO_SECTOR_SOURCE: "/cn/api/portfolio/composition/sector/allocation/v1/",
    FUND_PERFORMANCE_NAV_SOURCE: "/cn/api/accounting/navs/v1",
    FUND_PERFORMANCE_FUND_SOURCE: "/cn/api/performance/reinvested/prices/v1/",
    CEC_TRACKING_SOURCE: "/api/v1/public/track",
    FUND_DOCUMENT_SOURCE: "/es/search/reports",
};
